import React from 'react';
import './ServiceTime.css';

const ServiceTime = () => {
    return (
        <>
            <div className="card pt-3 pb-3">
                <div className="card-body">
                    <h5 class="card-title mb-4">Working Hours</h5>
                    <p class="card-text mb-4">Sun-Thu 12:05 PM to 8:00 PM <br />
                        Saturday 12:30 AM to 9:00 PM <br />
                        Friday Closed<br />
                    </p>

                    <p>
                        Phone: +880178888888 <br />
                        Email:  providence.hospital@gmail.com <br /><br />
                        Address:  Jindabazar, Sylhet</p>

                </div>
            </div>
        </>
    );
};

export default ServiceTime;